import { mdiMonitorEdit, mdiMonitorEye, mdiMonitorLock } from '@mdi/js';

const STATES = Object.freeze({
  CLOSED: 'CLOSED',
  CLOSED_WITH_SAR: 'CLOSED_WITH_SAR',
  HANDLING: 'HANDLING',
  PENDING: 'PENDING',
});

const COLORS = Object.freeze({
  [STATES.CLOSED]: 'green',
  [STATES.CLOSED_WITH_SAR]: 'green',
  [STATES.HANDLING]: 'blue',
  [STATES.PENDING]: 'orange',
});

const ICONS = Object.freeze({
  [STATES.CLOSED]: mdiMonitorLock,
  [STATES.CLOSED_WITH_SAR]: mdiMonitorLock,
  [STATES.HANDLING]: mdiMonitorEdit,
  [STATES.PENDING]: mdiMonitorEye,
});

export default Object.freeze({
  COLORS,
  ICONS,
  STATES,
});
